import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { TokenStorageService } from '@app/core/services/token-storage.service';
import { WorkCompUser } from '@app/core/interfaces/user.interface';
import {SaveResult} from "@app/shared/interfaces/saveResult.interface";

enum EP {
  GetAccountSettings = '/users',
}

@Injectable({
    providedIn: 'root'
})
export class WorkCompAccountSettingsService {
  constructor(
    private http: HttpClient,
    private tokenService: TokenStorageService
    ) { }

  getWorkCompAccountSettings$(): Observable<WorkCompUser> {
    const userId = this.tokenService.getEffectiveUser()?.id;
    return this.http.get<WorkCompUser>(`${environment.apiUrl}/users/work-comp/${userId}/settings-details`);
  }

  updateWorkCompAccountSettings$(updatedWorkCompUser: WorkCompUser) {
    const userId = this.tokenService.getEffectiveUser()?.id;
    return this.http.put<SaveResult>(`${environment.apiUrl}/users/work-comp/${userId}/settings-details`, updatedWorkCompUser);
  }
}
